export default {
  username: "Combination of 3 alphanumeric characters (0-9 A-Z)."
  // password: "Combination of 4 - 12 alphanumeric characters (0-9 A-Z)"
};